import { FagmoblerAlgoliaProduct } from '@fagmobler/types';
import { ProductCollectionCard, ProductListGridItem } from '@fagmobler/ui';
import { getCanonicalPath } from '@/lib/algolia/getCanonicalPath';
import { getTagsForDisplay } from '@/lib/algolia/tags';
import Link from 'next/link';
import Image from 'next/image';
import { fagmoblerSlugify } from '@/lib/utils/getUrls';
import { missingImageUrls } from '@/lib/utils/missingImageUrls';
import { useStores } from '@/components/store';
import { ServerPropertyValue } from '@/lib/janitsjar/Product';

export type ProductsInSerieProps = {
  serie: ServerPropertyValue;
  products: FagmoblerAlgoliaProduct[];
};

export function ProductsInSerie({ products, serie }: ProductsInSerieProps) {
  const { current: currentStoreQuery } = useStores();

  return (
    <div className="print:hidden">
      <ProductCollectionCard
        title={`Mer fra ${serie.value} serien`}
        href={`/serie/${fagmoblerSlugify(serie.value as string)}`}
        readMoreText={`Vis alle fra ${serie.value} serien`}
      >
        {products.map((item: FagmoblerAlgoliaProduct) => {
          const href = getCanonicalPath(item);
          const src = item.image;
          const hasImage = !!src && !missingImageUrls.includes(src);

          if (!href) return null;
          return (
            <Link href={href} key={item.objectID} className="block">
              <ProductListGridItem
                tags={getTagsForDisplay(item.tags, 2)}
                product={item}
                image={
                  hasImage && (
                    <Image
                      fill
                      src={src}
                      className="object-contain w-auto h-auto"
                      sizes="(max-width: 640px) 50vw, (max-width: 1024px) 164px, (max-width: 1280px) 166px, 211px"
                      alt={
                        item.posterName
                          ? `$Bilde av ${item.posterName} (${item.posterDescription})`
                          : 'Bilde av produkt'
                      }
                    />
                  )
                }
                store={currentStoreQuery?.data?.store}
              />
            </Link>
          );
        })}
      </ProductCollectionCard>
    </div>
  );
}

export default ProductsInSerie;
